module.exports = __webpack_public_path__ + "static/bootstrap-table-compact-9fb78be331db25eb247096f76692d194.png";